import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import API_BASE_URL from '../config';

const LandingPage = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [formMessage, setFormMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imageVersion, setImageVersion] = useState(Date.now());

  useEffect(() => {
    // Fade-up animation on load
    const elements = document.querySelectorAll('.fade-up');
    elements.forEach((el, i) => {
      setTimeout(() => {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      }, 200 * i);
    });
  }, []);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormMessage('');
    
    try {
      const response = await fetch(`${API_BASE_URL}/contact.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setFormMessage(data.message || 'Thank you for your message! We\'ll get back to you soon.');
        setFormData({ name: '', email: '', message: '' });
        
        // Auto-close modal after 3 seconds
        setTimeout(() => {
          setShowContactModal(false);
          setFormMessage('');
        }, 3000);
      } else {
        setFormMessage(data.message || 'Sorry, something went wrong. Please try again later.');
      }
    } catch (error) {
      console.error('Contact form error:', error);
      setFormMessage('Sorry, something went wrong. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const openPopup = (type) => {
    const content = getPopupContent(type);
    const popup = window.open('', '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    
    popup.document.write(`
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${content.title} - MHT</title>
        <style>
          body {
            font-family: 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.6;
            color: #212529;
            background: #F8F9FA;
            margin: 0;
            padding: 20px;
          }
          .popup-container {
            max-width: 700px;
            margin: 0 auto;
            background: white;
            padding: 40px;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          }
          h1 {
            color: #007BFF;
            margin-bottom: 30px;
            font-size: 28px;
            border-bottom: 2px solid #007BFF;
            padding-bottom: 10px;
          }
          h3 {
            color: #007BFF;
            margin: 25px 0 15px 0;
            font-size: 18px;
          }
          p {
            margin-bottom: 15px;
          }
          ul {
            margin: 15px 0;
            padding-left: 20px;
          }
          li {
            margin-bottom: 8px;
          }
          strong {
            color: #0056b3;
          }
          .close-btn {
            background: #007BFF;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            margin-top: 20px;
          }
          .close-btn:hover {
            background: #0056b3;
          }
        </style>
      </head>
      <body>
        <div class="popup-container">
          <h1>${content.title}</h1>
          ${content.body}
          <button class="close-btn" onclick="window.close()">Close Window</button>
        </div>
      </body>
      </html>
    `);
    
    popup.document.close();
  };

  const getPopupContent = (type) => {
    const contents = {
      terms: {
        title: "TERM OF USE - Model, Actor/Actress, Likeness, Image",
        body: `
          <p><strong>Effective Date: 11/01/2025</strong></p>
          <p>Welcome to Manhattan Hanover Talent ("MHT")! These Terms of Use ("Terms") govern your access to and use of the MHT website, mobile application, and digital services (collectively, the "Services"), operated by Manhattan Hanover Talent, LLC. ("MHT", "we", "our" or "us"). By accessing or using our Services, you agree to be bound by these Terms and our Privacy Policy, which is incorporated by reference.</p>
          <p>If you do not agree with these Terms, you may not access or use our Services.</p>
          
          <h3>1. Eligibility</h3>
          <p>You must be at least 18 years old or the legal age of majority in your jurisdiction to create an account to use our Services. If you are under the age of 18 or the legal age of majority in your jurisdiction, you must have the permission of your parent or guardian. By using the Services, you represent and warrant that you meet these requirements.</p>
          
          <h3>2. User Account</h3>
          <p>To access certain features (including revenue received, pending payments), you need to create an account. You agree to:</p>
          <ul>
            <li>Provide accurate, current, and complete information.</li>
            <li>Maintain the security of your account credentials.</li>
            <li>Be responsible for all activities that occur under your account.</li>
          </ul>
          <p>We reserve the right to suspend or terminate your account at our discretion, including for suspected fraud or violation of these Terms.</p>
          
          <h3>3. Digital Content and License</h3>
          <p>All digital content ("Content") available through the Services are licensed to you, not sold, and are subject to the following:</p>
          <ul>
            <li>You receive a limited, non-exclusive, non-transferable, revocable license to access and use the Content for personal, non-commercial purposes.</li>
            <li>You may not reproduce, distribute, publicly display, sell, rent, modify, create derivative works, or otherwise exploit the Content without express written permission from MHT or the applicable rights holder.</li>
          </ul>
          
          <h3>4. Compensation (Royalty-Based)</h3>
          <p>Talent will be paid a royalty based on several factors, which are different for each M²eBook placement. Compensation factors are:</p>
          <ul>
            <li>Number of M²eBooks sold involving Talent</li>
            <li>MHT's compensation from publishing company (M²eBook, LLC) on each M²eBook sold</li>
            <li>Number of Talents involved in the M²eBook</li>
            <li>Number of appearances in the M²eBook</li>
            <li>Number of chapters appearances in the M²eBook</li>
            <li>Number of videos (or 'Readeos') appearances in the M²eBook</li>
            <li>Talent's character designation: 'Main' or 'Support' or 'Background'</li>
            <li>Talent's social media following</li>
          </ul>
          
          <h3>5. Restrictions on Use</h3>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Services for any illegal purpose.</li>
            <li>Interfere with or disrupt the integrity of the Services.</li>
            <li>Reverse engineer, decompile, or disassemble any part of the Services.</li>
            <li>Circumvent DRM or access control mechanisms related to our Content.</li>
          </ul>
          
          <h3>6. Term and Termination</h3>
          <p>This Agreement is perpetual and survives the termination of any engagement or project, unless terminated in writing by mutual consent. Any materials already created or published prior to such termination may continue to be used indefinitely.</p>
          <p>We may suspend or terminate your access to the Services at any time for any reason, including violation of these Terms. Upon termination, your right to use the Services may be revoked, subject to applicable laws.</p>
          
          <h3>7. Intellectual Property</h3>
          <p>All materials provided by MHT, including the site/app design, text, graphics, logos, icons, and software, are the property of MHT or its licensors and are protected by intellectual property laws. All rights not expressly granted herein are reserved.</p>
          
          <h3>8. Third-Party Services and Links</h3>
          <p>The Services may contain links to third-party websites or services that are not owned or controlled by MHT. We are not responsible for the content or practices of any third party.</p>
          
          <h3>9. Disclaimers and Limitation of Liability</h3>
          <p>The Services and all content are provided "as is" without warranties of any kind. MHT does not guarantee uninterrupted or error-free access.</p>
          <p>To the maximum extent permitted by law, MHT shall not be liable for any indirect, incidental, special, or consequential damages resulting from your use of the Services or content.</p>
          
          <h3>10. Governing Law</h3>
          <p>These Terms are governed by the laws of Texas, USA without regard to conflict of law principles. You agree to submit to the exclusive jurisdiction of the courts located in Texas.</p>
          
          <h3>11. Changes to Terms</h3>
          <p>We may modify these Terms from time to time. If we make material changes, we will notify you via email or through the Services. Your continued use of the Services constitutes acceptance of the updated Terms.</p>
          
          <h3>12. Contact Us</h3>
          <p>If you have questions about these Terms, please contact us at:</p>
          <p>Email: <a href="mailto:contact@manhattanhanovertalent.com">contact@manhattanhanovertalent.com</a></p>
        `
      },
      privacy: {
        title: "Privacy Policy",
        body: `
          <p><strong>Last updated: 09/21/2025</strong></p>
          <p>Manhattan Hanover Talent, LLC ("MHT") is based in Texas, USA.</p>
          <p>More information about MHT is available at: <a href="http://manhattanhanovertalent.com" target="_blank">http://manhattanhanovertalent.com</a></p>
          <p>MHT operates a talent agency, along with associated websites and mobile applications. Our actors, models, authors, and casting clients use a variety of electronic devices, applications, and services to access and manage profiles, auditions, and project opportunities—collectively referred to as the "MHT Services."</p>
          <p>To access these services, individuals create an account (the "MHT Account") which they use in connection with MHT's services and features.</p>
          <p>This Privacy Policy explains how we collect, use, and disclose your personal information when you use your MHT Account or engage with any MHT websites, applications, or services that link to this Policy.</p>
          
          <h3>1. Collection of Personal Information</h3>
          <p>We collect, process, and use your Personal Information when you engage with Manhattan Hanover Talent, including when you:</p>
          <ul>
            <li>Register for or log in to an MHT Account;</li>
            <li>Submit or update your profile, audition materials, headshots, or resumes;</li>
            <li>Interact with MHT services, websites, applications, or marketing;</li>
            <li>Apply for casting opportunities or accept project assignments;</li>
            <li>Contact us for customer support or general inquiries.</li>
          </ul>
          <p>Personal Information refers to any information—or combination of information—that can reasonably be used to identify you or be linked to you.</p>
          <p>Sensitive Personal Information may include financial account details, login credentials, demographic or biometric information, or other data defined under privacy laws. MHT does not intentionally collect or store Sensitive Personal Information except as necessary for account access, payment processing, or client verification.</p>
          <p>Information that has been aggregated or de-identified so that it cannot reasonably be linked to an individual is not considered Personal Information. We may use such data for any lawful business purpose.</p>
          
          <p><strong>Categories of Personal Information We Collect:</strong></p>
          <ul>
            <li><strong>Identifiers:</strong> Name, email address, mailing address, phone number, username, password, IP address, and other online identifiers.</li>
            <li><strong>Professional Information:</strong> Headshots, resumes, reels, audition recordings, and other portfolio materials submitted by talent.</li>
            <li><strong>Demographics:</strong> Optional details such as age, gender.</li>
            <li><strong>Transactional Information:</strong> Payments for services, royalties, or reimbursements.</li>
            <li><strong>Online Activity:</strong> Browsing history, app usage, interaction with casting calls, and communications.</li>
            <li><strong>Billing & Location Data:</strong> To support payments and comply with industry, licensing, or territorial regulations.</li>
          </ul>
          <p><strong>Children's Data:</strong> MHT does not knowingly collect data from minors under 16 without parental consent.</p>
          
          <p><strong>Sources of Personal Information:</strong></p>
          <ul>
            <li>Directly from you (account setup, profile uploads, communications).</li>
            <li>Automatically collected (usage, device, and transactional data).</li>
            <li>From third parties (sign-in providers like Google or Apple, social media integrations, industry partners).</li>
            <li>Derived by us (internal IDs, inferred preferences, role suitability insights).</li>
          </ul>
          
          <h3>2. How and Why We Use Your Information</h3>
          <p>We may use your Personal Information to:</p>
          <ul>
            <li>Verify identity and authenticate accounts.</li>
            <li>Provide and operate the MHT Services (talent discovery, casting management, communication tools).</li>
            <li>Process payments, royalties, or reimbursements.</li>
            <li>Maintain and improve account functionality.</li>
            <li>Communicate with you about auditions, bookings, policy changes, or account issues.</li>
            <li>Personalize your experience (recommend roles, highlight talent to clients).</li>
            <li>Conduct analytics and improve service quality.</li>
            <li>Send marketing and promotional communications (with your consent where required).</li>
            <li>Comply with legal obligations, investigate fraud, or enforce contracts.</li>
            <li>Support contests, promotions, or events.</li>
          </ul>
          
          <h3>3. How We Share Information</h3>
          <p>MHT may share your Personal Information in the following circumstances:</p>
          <ul>
            <li><strong>Clients and Casting Partners:</strong> With author, content creators, production companies, publishers, and other verified clients seeking talent.</li>
            <li><strong>Service Providers:</strong> With third parties that support our operations (payment processors, hosting providers, analytics vendors, communication tools).</li>
            <li><strong>Marketing Partners:</strong> With advertising platforms or partners to deliver promotional campaigns, subject to your preferences.</li>
            <li><strong>Legal and Compliance:</strong> With regulators, courts, or law enforcement where required by law.</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred.</li>
          </ul>
          
          <h3>4. International Data Transfers</h3>
          <p>Your information may be transferred to service providers and partners in countries outside your home jurisdiction, including the United States, Canada, and Europe. Where required, we implement safeguards (e.g., Standard Contractual Clauses, adequacy decisions) to protect your data.</p>
          
          <h3>5. Legal Basis for Processing</h3>
          <p>Where GDPR or similar laws apply, MHT relies on the following legal bases:</p>
          <ul>
            <li>Contract performance (account access, bookings, payments).</li>
            <li>Consent (marketing, optional profile details).</li>
            <li>Legitimate interests (improving services, preventing fraud, ensuring security).</li>
            <li>Legal obligations (tax, regulatory, compliance).</li>
          </ul>
          
          <h3>6. Your Privacy Rights</h3>
          <p>Depending on your jurisdiction, you may have rights to:</p>
          <ul>
            <li>Access or request a copy of your personal data.</li>
            <li>Correct inaccuracies in your data.</li>
            <li>Request deletion ("right to be forgotten").</li>
            <li>Restrict or object to processing.</li>
            <li>Opt out of marketing or targeted advertising.</li>
            <li>Request data portability.</li>
            <li>Appeal decisions or lodge complaints with authorities.</li>
          </ul>
          <p>To exercise these rights, contact us at <a href="mailto:contact@manhattanhanovertalent.com">contact@manhattanhanovertalent.com</a></p>
          
          <h3>7. Your Choices</h3>
          <ul>
            <li><strong>Marketing:</strong> You can unsubscribe from promotional emails at any time.</li>
            <li><strong>Account Updates:</strong> You can update your profile and account information in your MHT Account settings.</li>
            <li><strong>Cookies:</strong> You can manage cookie preferences via your browser or our Privacy Settings.</li>
          </ul>
          
          <h3>8. Security and Retention</h3>
          <p>We use administrative, technical, and physical safeguards to protect your Personal Information. While no method is 100% secure, we continually improve our security measures.</p>
          <p>We retain your data as long as your MHT Account is active or as needed for business, legal, or compliance purposes. Aggregated or anonymized data may be retained indefinitely.</p>
          
          <h3>9. Third-Party Links</h3>
          <p>MHT Services may link to third-party websites or platforms (e.g., casting portals, publishers). MHT is not responsible for the privacy practices of those external sites.</p>
          
          <h3>10. Changes to This Policy</h3>
          <p>We may update this Privacy Policy periodically. The "Last Updated" date reflects the latest version. Significant changes may be communicated directly through your account or via email.</p>
          
          <h3>11. Contact Us</h3>
          <p>If you have questions about this Privacy Policy or how we handle your data, you may contact us at:</p>
          <p><a href="mailto:contact@manhattanhanovertalent.com">contact@manhattanhanovertalent.com</a></p>
        `
      },
      cookies: {
        title: "Cookie and Tracking Technology Policy",
        body: `
          <p><strong>Last Date Updated: 09/21/2025</strong></p>
          <p>At Manhattan Hanover Talent we are committed to protecting your privacy and providing transparency about the technologies we use. This Cookie and Tracking Technology Policy explains how we use cookies and similar technologies when you visit our website, use our ebook platform, or interact with our services.</p>
          
          <h3>1. What Are Cookies?</h3>
          <p>Cookies are small text files stored on your device (computer, smart phone, tablet) when you visit a website. They allow us to recognize your device and remember your preferences and actions.</p>
          
          <h3>2. Types of Cookies We Use</h3>
          
          <p><strong>Essential Cookies</strong></p>
          <p>These cookies are necessary for our website and Talent platform to function. They enable basic functions such as page navigation, secure access, and digital rights management (DRM).</p>
          
          <p><strong>Performance & Analytics Cookies</strong></p>
          <p>These cookies help us understand how visitors interact with our site, including which pages are viewed most often and how users move through the site. We use services like Google Analytics to improve our site and content delivery.</p>
          
          <p><strong>Functionality Cookies</strong></p>
          <p>These remember your preferences (e.g., language, display settings) to personalize your experience.</p>
          
          <p><strong>Marketing & Advertising Cookies</strong></p>
          <p>These cookies track your online activity to help us deliver relevant advertising and measure campaign performance. We may partner with third-party ad networks and platforms (e.g., Google Ads, Meta) for this purpose.</p>
          
          <h3>3. Tracking Technologies We May Use</h3>
          <p>We may also use tracking pixels (also known as web beacons), tags, and scripts to analyze trends, administer the site, track users' movements, and gather demographic information.</p>
          
          <h3>4. How to Manage Cookies</h3>
          <p>You can control or delete cookies through your browser settings. You can also opt out of third-party tracking by visiting:</p>
          <p><a href="https://tools.google.com/dlpage/gaoptout" target="_blank">Google Analytics Opt-out</a></p>
          <p>Please note that disabling cookies may affect your user experience and some features of our site may not function properly.</p>
          
          <h3>5. Changes to This Policy</h3>
          <p>We may update this policy periodically. Changes will be posted on this page with an updated revision date. We encourage you to review this policy regularly.</p>
          
          <h3>6. Contact Us</h3>
          <p>If you have any questions about this policy or how we use cookies, please contact us at:</p>
          <p><strong>Manhattan Hanover Talent, LLC</strong></p>
          <p>Email: <a href="mailto:help@manhattanhanovertalent.com">help@manhattanhanovertalent.com</a></p>
        `
      },
      faq: {
        title: "Frequently Asked Question (FAQ)",
        body: `
          <h2>What is Manhattan Hanover Talent (MHT)?</h2>
          <p>Manhattan Hanover Talent (MHT) is a professional talent agency with an exclusive partnership with the multimedia publisher M²eBooks (visit m2ebooks.com).</p>
          <p>We connect talent, like you, with authors who want to bring their book characters to life.</p>
          <p>When selected your likeness appears throughout an author's M²eBook in visual and video form.</p>

          <h2>What is expected of me?</h2>
          <p>If Manhattan Hanover Talent (MHT) successfully places you with an author, your image and likeness will be used to represent one of their characters.</p>
          <p>There are no auditions or casting calls. M²eBooks' proprietary AI technology uses your photos to create visuals and videos that match the author's vision.</p>

          <h2>How do I join?</h2>
          <p>Click the JOIN button on Manhattan Hanover Talent's (MHT'S) homepage and complete your profile by providing basic information such as gender and age, along with two photos:</p>
          <ul>
            <li>A headshot, and</li>
            <li>A full-body shot.</li>
          </ul>
          <p>Once your profile is submitted, MHT begins working to match you with an author and place you in an M²eBook!</p>

          <h2>What information do I need to provide?</h2>
          <p>To create your account, you'll need an email address and a password. Once accomplished, your account is active, we'll ask for the following:</p>
          <ul>
            <li>Full name</li>
            <li>Address and phone number</li>
            <li>Date of birth</li>
            <li>Height</li>
            <li>Gender</li>
            <li>Two photos (head shot and full-body)</li>
          </ul>

          <h2>Does it cost money to join?</h2>
          <p>No – it completely free to join Manhattan Hanover Talent (MHT). We only earn money when you do — taking 20% of the income we generate for you.</p>

          <h2>How do I make money?</h2>
          <p>Once an author selects you to appear as a character in their M²eBook, you'll earn royalties each time that book is sold.</p>
          <p>Your earnings depend on several factors, including:</p>
          <ul>
            <li>Number of characters featured in the M²eBook</li>
            <li>Number of total and chapter appearances</li>
            <li>Number of video features</li>
            <li>Your social media reach and verified followers count</li>
            <li>Character type (Main, Supporting, or Background)</li>
          </ul>

          <h2>What increases my chances of being selected?</h2>
          <p>To improve your chances:</p>
          <ul>
            <li>Two strong photos (a clear headshot and a full-body image)</li>
            <li>Maintain an active social media presence with solid engagement</li>
            <li>Show enthusiasm for promotion—helping the author share visuals and videos before and after the book's release.</li>
          </ul>
          <p>Your collaboration helps boost both your visibility and the M²eBook's success.</p>

          <h2>What is M²eBooks and how are they involved?</h2>
          <p>M²eBook is a next-generation publishing company that transforms traditional stories into immersive experiences.</p>
          <p>Their proprietary AI blends text, video, audio, and interactivity—creating a new kind of eBook where reading meets watching, listening and interactivity.</p>

          <h2>If I'm chosen for an M²eBook, can I decline?</h2>
          <p>Yes. You may decline any opportunity that doesn't feel right for you.</p>
          <p>Like the movie industry, M²eBooks includes content advisories for mature or sensitive themes, so you'll always know what to expect before accepting a role.</p>

          <h2>Is there an age restriction?</h2>
          <p>There is no specific age restriction.</p>
          <p>However, participants under the age of 18 must have a parent or guardian consent.</p>
          <p>Since M²eBooks reflect real-world stories, authors often need characters of all ages.</p>
        `
      }
    };
    
    return contents[type] || { title: "Document", body: "<p>Content not found.</p>" };
  };

  return (
    <div className="landing-page">
      <header>
        <div className="logo">
          <div className="mark">
            <div className="logo-main">Manhattan Hanover Talent</div>
            <div className="logo-tagline">a talent agency</div>
          </div>
        </div>
        <nav className="header-nav">
          <Link to="/login" className="nav-btn">Sign In</Link>
          <Link to="/register" className="nav-btn primary">Sign up</Link>
          <button className="nav-btn" onClick={() => setShowContactModal(true)}>Contact</button>
          <button className="nav-btn" onClick={() => setShowAboutModal(true)}>About</button>
          <button className="nav-btn" onClick={() => openPopup('faq')}>FAQ</button>
        </nav>
      </header>

      <section className="hero">
        <div className="hero-background">
          <img 
            src={`/latest.png?v=${imageVersion}`}
            alt="Manhattan Hanover Talent" 
            className="hero-bg-image"
            loading="eager"
            key={imageVersion}
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              display: 'block',
              minHeight: '100%'
            }}
            onError={(e) => {
              console.error('Failed to load latest.png:', e);
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.display = 'none';
            }}
            onLoad={(e) => {
              console.log('latest.png loaded successfully');
              e.target.style.opacity = '1';
            }}
          />
        </div>
        <div className="hero-content">
          <div className="hero-copy fade-up">
            <p className="lead">BRINGING TALENT TO THE PAGE</p>
          </div>
        </div>
      </section>

      <section className="section carousel-wrap" aria-labelledby="talent">
        <div className="carousel-container">
          <div className="carousel">
            <div className="headshot"><img src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e" alt="Headshot 1" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1599566150163-29194dcaad36" alt="Headshot 2" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1" alt="Headshot 3" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1607746882042-944635dfe10e" alt="Headshot 4" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1520813792240-56fc4a3765a7" alt="Headshot 5" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde" alt="Headshot 6" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330" alt="Headshot 7" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1552058544-f2b08422138a" alt="Headshot 9" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e" alt="Headshot 10" /></div>
            {/* Duplicate for seamless loop */}
            <div className="headshot"><img src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e" alt="Headshot 1" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1" alt="Headshot 3" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1607746882042-944635dfe10e" alt="Headshot 4" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1520813792240-56fc4a3765a7" alt="Headshot 5" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde" alt="Headshot 6" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330" alt="Headshot 7" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1552058544-f2b08422138a" alt="Headshot 9" /></div>
            <div className="headshot"><img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e" alt="Headshot 10" /></div>
          </div>
          
          {/* <div className="join-button-center">
            <Link to="/register" className="join-button">
              <span className="join-text">Sign up</span>
              <span className="join-subtitle">Start Your Journey</span>
              <div className="join-icon">✨</div>
            </Link>
          </div> */}
        </div>
      </section>

      <section className="section cta-section">
        <div className="cta-container">
          <h2>Ready to Start Your Journey?</h2>
          <p>Join Manhattan Hanover Talent and become part of the future of multimedia eBooks.</p>
          <div className="cta-buttons">
            <Link to="/register" className="btn primary large">Sign up Now</Link>
            <Link to="/login" className="btn secondary large">Already a Member? Sign In</Link>
          </div>
        </div>
      </section>

      <section className="legal-tabs">
        <div className="tabs-container">
          <div className="tabs-header">
            <button className="tab-button" onClick={() => openPopup('terms')}>Terms of Use</button>
            <button className="tab-button" onClick={() => openPopup('privacy')}>Privacy Policy</button>
            <button className="tab-button" onClick={() => openPopup('cookies')}>Cookie Policy</button>
          </div>
        </div>
      </section>

      {/* Contact Form Modal */}
      {showContactModal && (
        <div className="modal" onClick={(e) => e.target.className === 'modal' && setShowContactModal(false)}>
          <div className="modal-content">
            <span className="close" onClick={() => setShowContactModal(false)}>&times;</span>
            <h2>Contact Manhattan Hanover Talent</h2>
            <p>Get in touch with us for inquiries about our talent services.</p>
            
            <form onSubmit={handleContactSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleInputChange}
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleInputChange}
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="5" 
                  value={formData.message}
                  onChange={handleInputChange}
                  required 
                  placeholder="Tell us about your project or inquiry..."
                />
              </div>
              
              <div className="form-actions">
                <button type="button" className="btn secondary" onClick={() => setShowContactModal(false)}>Cancel</button>
                <button type="submit" className="btn primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </div>
            </form>
            
            {formMessage && (
              <div className={`form-message ${formMessage.includes('Thank you') ? 'success' : 'error'}`}>
                {formMessage}
              </div>
            )}
          </div>
        </div>
      )}

      {/* About Popup Modal */}
      {showAboutModal && (
        <div className="modal" onClick={(e) => e.target.className === 'modal' && setShowAboutModal(false)}>
          <div className="modal-content about-content">
            <span className="close" onClick={() => setShowAboutModal(false)}>&times;</span>
            <h2>About Manhattan Hanover Talent</h2>
            <div className="about-text">
              <p>Step into the future of entertainment with Manhattan Hanover Talent, the first agency built exclusively for multimedia eBooks. We connect real people like you with authors and publishers who want their stories to come alive using authentic faces and personalities. As part of our agency, your image and likeness will be featured in groundbreaking eBooks that blend storytelling with dynamic visuals and videos. Best of all, you'll earn ongoing royalties for every copy sold — no upfront costs, no auditions, no hassle. We only take 20% of the royalties for securing you the work, meaning your success directly translates into income.</p>
              
              <p>And here's where the opportunity becomes truly global: every eBook is distributed internationally to readers in over a dozen countries — including France, Germany, the UK, Greece, Canada, and Australia. That means your image, your role, and your story appearances have the chance to be seen by audiences worldwide. Add to that the power of your own family, friends, and fans — who help drive sales, exposure and momentum — and you have a partnership model where everyone wins. The author's reach combines with your network, creating a multiplying effect that expands your royalties and your fan base at the same time.</p>
              
              <p>What's more, each eBook is interactive. Every photo and video of you inside the eBook has built-in social features, allowing readers to like, comment, and share your scenes. This creates ongoing buzz, viral visibility, and growing U.S. and international recognition for you as part of the story. Joining is simple — create an account with your email and password, upload two photos, and add some basic information about yourself. From there, our proprietary AI brings your image to life—styling your outfits, expressions and roles for each scene, so no photo shoots or auditions are ever required. Once your profile is complete, just sit back, let your image travel the world, and watch your royalties — and your fan base — grow.</p>
            </div>
            <div className="about-actions">
              <button className="btn primary" onClick={() => setShowAboutModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      <footer>
        © Manhattan Hanover Talent™ — Making characters visible. All rights reserved.
      </footer>
    </div>
  );
};

export default LandingPage;
